import gql from 'graphql-tag'
import { rejectResponseAbove, interceptGraphQLErrors } from './utils'
import { sleeper } from '../utils'
import { appPath, generateConfig } from '../config'

export function getOrganizationFromDomain({ apiUrl }, domain) {
  return fetch(`${apiUrl}/organizations/domains/${domain}`)
    .then(async (response) => {
      if (response.status > 400) {
        try {
          const { errors } = await response.json()
          throw errors
        } catch (e) {
          if (e.id) {
            throw e
          }
          throw new Error('Unable to check domain availability')
        }
      }
      return response
    })
    .then((response) => response.json())
    .then(({ data }) => data.attributes)
}

export function isDomainAvailable({ apiUrl }, domain) {
  return getOrganizationFromDomain({ apiUrl }, domain).then(
    ({ available }) => available
  )
}

export async function join(
  { apiUrl },
  domain,
  user,
  emailVerificationCode,
  organizationInviteToken = null,
  joinOrigin = null
) {
  const abFlagsIds = generateConfig().abFlags
  return fetch(`/api/auth/organizations/auto-join`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      user: {
        ...user,
        displayName: user.displayName,
        abFlagsIds,
      },
      emailVerificationCode,
      domain,
      // for orga invite links
      inviteToken: organizationInviteToken,
      joinOrigin,
    }),
  })
    .then(rejectResponseAbove(400))
    .then((response) => response.json())
    .then(sleeper(1000))
    .then(({ data, included }) => {
      const organization = data.attributes
      const user = included.find(({ type }) => type === 'users').attributes
      const authTokens = included.find(
        ({ type }) => type === 'authTokens'
      ).attributes

      return { organization, user, authTokens }
    })
}

export async function fetchOrganizationPublicInfosByDomain(
  { apolloClient },
  { domain }
) {
  return apolloClient
    .query({
      query: gql`
        query fetchOrganizationPublicInfosByDomain($domain: String!) {
          showPublicOrganization(domain: $domain) {
            id
            name
            domain
            photoURL
            authMethod
            authDomains
            membersCanAutoJoinByDomain
            authProvider {
              name
            }
          }
        }
      `,
      variables: { domain },
    })
    .then(interceptGraphQLErrors)
    .then((response) => response.data.showPublicOrganization)
}
export async function verifyOrganizationInviteToken(
  { apiUrl },
  { organizationInviteToken, organizationId }
) {
  const response = await fetch(
    `${apiUrl}/auth/organizaton-invite-token/verify`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        data: {
          attributes: {
            organizationId,
            token: organizationInviteToken,
          },
        },
      }),
    }
  )

  try {
    const result = await response.json()

    if (result.errors || !result.data.success) {
      throw new Error('invite token verification failed.')
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('invite token verification error', error)
    throw new Error('This token is invalid.')
  }
}

export function getOrganizations({ apiUrl, email, isDesktop }) {
  return fetch(
    `${apiUrl}/users/${email}/joinOrganizationByEmail?isDesktop=${isDesktop}&appPath=${appPath}`,
    {
      method: 'POST',
    }
  ).then(rejectResponseAbove(400))
}
